import React, { useEffect, useState } from 'react'
import { Button, ButtonToolbar } from 'react-bootstrap'
import { connect, useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'

import { api_gateway } from '../../../conexoes/api'
import editarVerde from '../../../icones/editarVerde.svg'
import eyeBlue from '../../../icones/eyeBlue.svg'
import {
  desabilitarAcoes,
  limpadorFiltros,
  limpouBusca,
  mudarFiltros,
  mudarManejador,
  realizouBusca,
  realizouFiltro,
  revelarBarraFiltragem
} from '../../../redux/actions/index'
import ROUTERS from '../../../statics/routers.json'
import { lixeira } from '../../../utils/alternanciaIcones'
import { formatarData } from '../../../utils/formatadorDataTabela'
import MensagemConfirmarExclusao from '../../componentesModais/mensagens/mensagemConfirmarExclusao'
import MensagemErro from '../../componentesModais/mensagens/mensagemErro'
import MensagemSucesso from '../../componentesModais/mensagens/mensagemSucesso'
import ModalDetalhesVersao from '../../releaseNotes/ModalDetalhesVersao'
import SpinerVeye from '../../spinnerVeye/spinnerVeye.js'
import Table from '../../Table/index.jsx'

import CadastrarVersao from './cadastro'

import '../../../css/painelAdministrativo/pavUsuario/pavUsuario.css'
import './tabela.css'

let contador = 0
let controladorPagina = 1
let totalPaginas = 0
let totalItens = 0
let cadastrouOuDeletou = false
let valorLimite = 50

function Grid() {
  let storeCdVersao = -1
  const [spinAtivo, setSpinAtivo] = useState(true)
  const [itens, setItens] = useState([])
  const [paginaAtual, setPaginaAtual] = useState(1)
  const [renderizar, setRenderizar] = useState(false)
  const [cdVersionamento, setCdVersionamento] = useState('')
  const [dsVersao, setDsVersao] = useState('')
  const [mensagemErro, setMensagemErro] = useState(
    'Ocorreu um erro ao executar esta ação'
  )
  const [revelarMensagemAtencao, setRevelarMensagemAtencao] = useState(false)
  const [revelarMensagemErro, setRevelarMensagemErro] = useState(false)
  const [revelarMensagemSucesso, setRevelarMensagemSucesso] = useState(false)
  const [revelarCadastro, setRevelarCadastro] = useState(false)
  const [revelarEdicao, setRevelarEdicao] = useState(false)
  const [deletarVersao, setDeletarVersao] = useState()

  const [revelarMenuReleaseNotes, setRevelarMenuReleaseNotes] = useState(false)

  const despacho = useDispatch()
  let conteudoBusca = useSelector((state) => state.manejadorState.conteudoBusca)
  let limpouBuscaGeral = useSelector(
    (state) => state.manejadorState.limpouBusca
  )
  let realizouBuscaGeral = useSelector(
    (state) => state.manejadorState.realizouBusca
  )
  let realizouFiltragem = useSelector(
    (state) => state.manejadorState.realizouFiltro
  )
  let filtros = useSelector((state) => state.filtrosState.filtros)

  const location = useLocation()
  const isPermissoesAdm = location.pathname === ROUTERS.painelVersionamento

  let itensVar = []
  // USABILIDADE
  const [coletaUsabilidade, setColetaUsabilidade] = useState(true)

  useEffect(() => {
    if (coletaUsabilidade) {
      // ColetaClickstream(120) // 'pavUsuarioTabelaGrid'
      setColetaUsabilidade(false)
    }
  }, [])

  useEffect(() => {
    despacho(revelarBarraFiltragem(false))
    if (!filtros.vazio) {
      despacho(mudarFiltros({ vazio: 'vazio' }))
    }
    despacho(limpadorFiltros(true))
  }, [])

  useEffect(() => {
    setSpinAtivo(true)
    despacho(mudarManejador('versionamento'))
    despacho(desabilitarAcoes(true))

    async function carregarTabela() {
      //clicou no botão de limpar a busca geral e retorna tudo ao estado original
      if (limpouBuscaGeral) {
        despacho(limpouBusca(false))
        restaurarConfigsIniciaisPagina()
      }

      //clicou no botão de busca geral
      if (realizouBuscaGeral) {
        despacho(realizouBusca(false))
        restaurarConfigsIniciaisPagina()
      }

      //clicou no botão para filtro
      if (realizouFiltragem) {
        despacho(realizouFiltro(false))
        restaurarConfigsIniciaisPagina()
      }

      if (conteudoBusca && filtros.vazio) {
        if (totalPaginas == 0) {
          contador = 0
          itensVar = []
          setItens([])
          await contarItens()
        } else {
          contador = (paginaAtual - 1) * valorLimite
        }
        if (controladorPagina <= paginaAtual) {
          await contarItens()

          const queryString = `?paginaAtual=${contador}&carregarLimit=${valorLimite}&buscar=${conteudoBusca}`

          const { data } = await api_gateway.get(
            '/m1/filtrar/versionamento' + queryString
          )
          inserirData(data.dados)
        }
      } else if (!filtros.vazio) {
        if (totalPaginas == 0) {
          contador = 0
          itensVar = []
          setItens([])
          await contarItens()
        } else {
          contador = (paginaAtual - 1) * valorLimite
        }
        const dados = {
          paginaAtual: contador,
          carregarLimit: valorLimite,
          buscar: conteudoBusca,
          filtros: filtros
        }
        if (controladorPagina <= paginaAtual) {
          const { data } = await api_gateway.post(
            '/m1/filtrar/versionamento',
            dados
          )
          inserirData(data.dados)
        }
      } else {
        if (totalPaginas == 0 || cadastrouOuDeletou) {
          await contarItens()
          if (cadastrouOuDeletou) cadastrouOuDeletou = false
        } else {
          contador = (paginaAtual - 1) * valorLimite
        }
        if (controladorPagina <= paginaAtual) {
          const queryString =
            '?paginaAtual=' +
            contador +
            '\
                                        &carregarLimit=' +
            valorLimite

          const { data } = await api_gateway.get(
            '/m1/filtrar/versionamento' + queryString
          )

          inserirData(data.dados)
        }
      }
      setSpinAtivo(false)
    }
    carregarTabela()
  }, [paginaAtual, conteudoBusca, renderizar, filtros])

  function inserirData(data) {
    for (let i = 0; i < totalItens; i++) {
      if (contador === i) {
        let k = i
        for (let j = 0; j < data.length; j++) {
          itensVar[k] = data[j]
          k++
        }
      }
      if (i == totalItens - 1) {
        setItens(JSON.parse(JSON.stringify(itensVar)))
      }
    }
  }

  async function contarItens() {
    let arrayItens = []
    let apiData = []
    if (controladorPagina <= paginaAtual) {
      if (controladorPagina <= paginaAtual && filtros.vazio) {
        const queryString = '?contar=true&buscar=' + conteudoBusca

        apiData = await api_gateway.get(
          '/m1/filtrar/versionamento' + queryString
        )
      } else {
        const dados = {
          paginaAtual: contador,
          carregarLimit: valorLimite,
          buscar: conteudoBusca,
          filtros: filtros,
          contar: true
        }
        apiData = await api_gateway.post('/m1/filtrar/versionamento', dados)
      }
      itensVar = []

      if (apiData.data.dados) {
        totalPaginas = Math.ceil(apiData.data.dados[0].CONTADOR / valorLimite)
        totalItens = apiData.data.dados[0].CONTADOR
        for (var i = 0; i < apiData.data.dados[0].CONTADOR; i++) {
          arrayItens.push(i)
        }
        itensVar = arrayItens
      }
    }
  }

  function restaurarConfigsIniciaisPagina() {
    totalPaginas = 0
    contador = 0
    controladorPagina = 1
    totalItens = 0
    setPaginaAtual(1)
  }

  let colunas = [
    {
      dataField: 'ds_release',
      text: 'Versão',
      sort: true,
      headerClasses: 'nao-selecionavel',
      formatter: (cell) => {
        if (!cell) {
          return <p className="fonte-cor-1 label-tabela-1">-</p>
        } else {
          return <p className="fonte-cor-1 label-tabela-1">{cell}</p>
        }
      }
    },
    {
      dataField: 'dt_created_at',
      text: 'Data',
      sort: true,
      headerClasses: 'nao-selecionavel',
      formatter: (cell) => {
        if (!cell) {
          return <p className="fonte-cor-1 label-tabela-1">-</p>
        } else {
          return formatarData(cell, true)
          // return <p className="fonte-cor-1 label-tabela-1">{cell}</p>;
        }
      }
    },
    {
      dataField: 'cd_pav_release',
      text: 'Visualizar',
      sort: true,
      headerClasses: 'nao-selecionavel',
      formatter: (cell) => {
        return (
          <Button
            className="div-visualizar-versao"
            onClick={() => {
              setRevelarMenuReleaseNotes(true)
              setCdVersionamento(cell)
            }}
          >
            <img
              className="btn-visualizar-versao"
              alt="visualizar detalhes"
              src={eyeBlue}
            />
          </Button>
        )
      }
    }
  ]

  const colunasAdm = [
    {
      dataField: 'responsavel',
      text: 'Responsável',
      sort: true,
      headerClasses: 'nao-selecionavel',
      formatter: (cell) => {
        if (!cell) {
          return <p className="fonte-cor-1 label-tabela-1">-</p>
        } else {
          return <p className="fonte-cor-1 label-tabela-1">{cell}</p>
        }
      }
    },
    {
      dataField: 'cd_pav_release',
      text: 'Ações',
      sort: true,
      headerClasses: 'nao-selecionavel',
      formatter: (cell, row) => {
        // if(!cell){
        //     return <p className="fonte-cor-1 label-tabela-1">-</p>
        // }else{
        return (
          <ButtonToolbar className="btn-toolbar-versao">
            <Button
              className="btn-editar-versao"
              onClick={() => handleExpandirEdicao(cell)}
            >
              <img alt="editar" src={editarVerde} />
            </Button>
            <Button
              className="btn-apagar-versao"
              onClick={() => handleMensagemAtencao(false, cell, row.ds_release)}
            >
              <img alt="lixeiraVermelho" src={lixeira()} />
            </Button>
          </ButtonToolbar>
        )
        // }
      }
    }
  ]

  if (isPermissoesAdm) {
    colunas = [...colunas, ...colunasAdm]
  }

  async function handleDeletar(cdExcluir) {
    setSpinAtivo(true)
    await api_gateway
      .get('/m1/deletar/versionamento?cd_pav_release=' + cdExcluir) //+cdVersionamento)
      .then(() => {
        setSpinAtivo(false)
        handleMensagemSucesso(false)
        cadastrouOuDeletou = true
      })
      .catch((error) => {
        setSpinAtivo(false)
        setMensagemErro(error.response.data.info)
        handleMensagemErro(false)
      })
  }

  function handleMensagemAtencao(confirmacao, cd_pav_release, versao) {
    setDsVersao(versao)

    if (revelarMensagemAtencao === false) {
      setRevelarMensagemAtencao(true)
    } else {
      setRevelarMensagemAtencao(false)
    }
    if (!confirmacao) {
      setDeletarVersao(cd_pav_release)
    }
    if (confirmacao && revelarMensagemAtencao) {
      handleDeletar(deletarVersao)
    }
    setRenderizar(!renderizar)
  }

  function handleMensagemErro() {
    if (revelarMensagemErro === false) {
      setRevelarMensagemErro(true)
    } else {
      setRevelarMensagemErro(false)
    }
  }

  function handleMensagemSucesso(confirmacao) {
    if (revelarMensagemSucesso === false) {
      setRevelarMensagemSucesso(true)
    } else {
      setRevelarMensagemSucesso(false)
    }
    if (confirmacao === true) {
      setRenderizar(!renderizar)
    }
  }

  function handleExpandirEdicao(Param) {
    setCdVersionamento(Param)
    if (Param != storeCdVersao) {
      setRevelarEdicao(false)
      // setRevelarConfiguracao(false)
      // setNomeGrupo('Selecione')
    }
    storeCdVersao = Param
    if (revelarEdicao === true) {
      setRevelarEdicao(false)
      // setRevelarConfiguracao(false)
      // setNomeGrupo('Selecione')
    } else {
      setRevelarEdicao(true)
      // setRevelarConfiguracao(false)
    }
  }

  const getLimiteNaPagina = () =>
    contador + valorLimite <= totalItens ? contador + valorLimite : totalItens
  const getTotalItensNaPagina = () => getLimiteNaPagina()

  const trocarPagina = (novaPagina) => {
    if (totalPaginas <= 1) return

    setPaginaAtual(novaPagina)
  }

  return (
    <>
      <Table
        keyField="cd_pav_release"
        clickToSelect
        revelarContador
        itens={itens}
        colunas={colunas}
        getTotalItensNaPagina={getTotalItensNaPagina}
        getLimiteNaPagina={getTotalItensNaPagina}
        pagination={{
          paginaAtual,
          valorLimite,
          totalPaginas,
          totalItens,
          contador,
          trocarPagina
        }}
      />

      {spinAtivo && (
        <div className="componente-spinner-overlay">
          <div className="componente-spinner-container">
            <SpinerVeye />
          </div>
        </div>
      )}
      {revelarMenuReleaseNotes === true && (
        <div className="componente-modal-overlay-novidades">
          <div className="componente-modal">
            <ModalDetalhesVersao
              setRevelarMenuReleaseNotes={setRevelarMenuReleaseNotes}
              cd_pav_release={cdVersionamento}
            />
          </div>
        </div>
      )}

      {revelarCadastro === true && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <CadastrarVersao
              fecharModal={() => setRevelarCadastro(false)}
              tituloJanela="Cadastrar"
              setRevelarCadastro={setRevelarCadastro}
              renderizar={renderizar}
              setRenderizar={setRenderizar}
              cadastrou={() => (cadastrouOuDeletou = true)}
            />
          </div>
        </div>
      )}
      {revelarEdicao && ( // EditarUsuario === true &&
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <CadastrarVersao
              fecharModal={() => setRevelarEdicao(false)}
              tituloJanela="Editar"
              cdVersionamento={cdVersionamento}
              // dsVersao={dsVersao}
              // dtCreated={dtCreated}
              setRevelarCadastro={setRevelarEdicao}
              renderizar={renderizar}
              setRenderizar={setRenderizar}
            />
          </div>
        </div>
      )}
      {isPermissoesAdm && (
        <Button
          onClick={() => setRevelarCadastro(true)}
          className="botao-confirmar btn-nova-versao"
          variant="success"
          size="sm"
        >
          <div className="fonte-cor-4">CRIAR NOVA VERSÃO</div>
        </Button>
      )}

      {revelarMensagemSucesso && (
        <MensagemSucesso
          handleMensagemSucesso={handleMensagemSucesso}
          mensagemTitulo="Sucesso"
          mensagemParagrafo1="Versão deletada."
          mensagemBotao="Continuar"
        />
      )}
      {revelarMensagemAtencao && ( //ExcluirUsuario &&
        <MensagemConfirmarExclusao
          handleMensagemAtencao={handleMensagemAtencao}
          mensagemTitulo={'Deletar versão ' + dsVersao}
        />
      )}
      {revelarMensagemErro && (
        <MensagemErro
          handleMensagemErro={handleMensagemErro}
          mensagemTitulo={mensagemErro}
          mensagemParagrafo1="Erro"
          mensagemParagrafo2={mensagemErro}
          mensagemBotao="Retornar"
        />
      )}
    </>
  )
}

function mapStateToProps(state) {
  return {
    conteudoBusca: state.manejadorState.conteudoBusca,
    filtros: state.filtrosState.filtros
  }
}
//React.memo - nao permitir a renderizacao se o state e o props nao mudarem de estado
export default connect(mapStateToProps)(React.memo(Grid))
